import { Box, Tooltip, Typography } from "@mui/material"
import ProntoAiOpportunityAddIcon from "../../Icons/ProntoAiOpportuntiyAddIcon"
import { useDispatch } from "react-redux"
import {
  setIsProntoAiLoading,
  setSelectedMetric,
} from "../../../redux/slices/prontoAiSlice"
import { colors } from "../../../../styles/commonStyles"

type ProntoAiMetricNameCellType = {
  row: any
  renderedCellValue: any
  toggleDrawer: any
  handleFetchStoreById: any
}

const ProntoAiMetricNameCell = (props: ProntoAiMetricNameCellType) => {
  const dispatch = useDispatch()

  const { row, renderedCellValue, toggleDrawer, handleFetchStoreById } = props

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 10px",
      }}
      onClick={() => {
        dispatch(setIsProntoAiLoading(true))
        dispatch(
          setSelectedMetric({
            metric_id: row?.original?.metric_id,
            group_sk: row?.original?.group_sk,
            region: row?.original?.region,
            practice_sk: row?.original?.practice_sk,
            metric_store_id: row?.original?.metric_store_id,
            practice_name: row?.original?.practice_name,
            Metric: row?.original?.Metric,
          }),
        )
      }}
    >
      <Box
        sx={{ cursor: "pointer", display: "flex", flexDirection: "column" }}
        onClick={toggleDrawer("right", true)}
      >
        <Tooltip title={row?.original?.metric_hover_text} placement="right">
          <Typography sx={{}} fontWeight={700} color={"#3C77EF"}>
            {renderedCellValue}
          </Typography>
        </Tooltip>
        <Typography fontSize={10} fontWeight={500} color={colors.grey300}>
          {row?.original?.practice_name}
        </Typography>
      </Box>
      <Box>
        <ProntoAiOpportunityAddIcon
          row={row}
          handleFetchStoreById={handleFetchStoreById}
        />
      </Box>
    </Box>
  )
}

export default ProntoAiMetricNameCell
